<template>
  <v-app>
    <v-app-bar app color="white" height="100">
      <nuxt-link to="/">
        <v-img
          max-height="100"
          max-width="250"
          contain
          :src="'customers/afocelca/afocelca_color_horizontal_transparente.png'"
        />
      </nuxt-link>
      <v-spacer />
      <client-only>
        <v-btn
          v-if="$auth.user"
          class="ml-4 font-weight-black"
          text
          nuxt
          to="/apps"
        >
          {{ $t("apps") }}
        </v-btn>
        <v-btn
          v-if="!$auth.user"
          style="margin-right: 2.75rem"
          class="ml-4 font-weight-black"
          text
          nuxt
          to="login"
        >
          <v-avatar class="mr-3" size="30">
            <v-img :src="'customers/afocelca/login.png'" />
          </v-avatar>
          {{ $t("login") }}
        </v-btn>
        <v-btn
          v-else
          class="ml-4 mr-9 font-weight-black"
          text
          @click="$auth.logout()"
        >
          {{ $t("logout") }}
        </v-btn>
      </client-only>
    </v-app-bar>

    <v-main>
      <nuxt />
    </v-main>
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";

export default {
  components: { Snackbar },
  data({ $config }) {
    return {
      customer: $config.CUSTOMER,
    };
  },
  head() {
    return {
      link: [
        {
          rel: "stylesheet",
          type: "text/css",
          href: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;800&display=swap",
        },
      ],
    };
  },
};
</script>
